import { render, staticRenderFns } from "./BaseSelectRadio.vue?vue&type=template&id=452aa1fa&"
import script from "./BaseSelectRadio.vue?vue&type=script&lang=js&"
export * from "./BaseSelectRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports